import {ApiGetRaw, ApiPatch, ApiPost} from "./api-service";

const resetPassword = (email) =>
  ApiPost('/api/v1/users/reset-password', {username: email});

const resendPassword = (guid) =>
  ApiPost(`/api/v1/users/${guid}/temp-password`);

const updatePassword = (guid) =>
  ApiPatch(`/api/v1/users/${guid}/temp-password`);

const showTempPass = (guid) =>
  ApiGetRaw(`/api/v1/users/${guid}/temp-password`);

export {
  resetPassword,
  resendPassword,
  updatePassword,
  showTempPass
}
